export default __webpack_public_path__ + "static/media/zayed-project-1.f151b1c4.jpg";